import React, { useEffect, useState } from "react";
import {
  Box, Button, Card, CardContent, Chip, CircularProgress, Grid,
  TextField, Typography
} from "@material-ui/core";
import { Email as EmailIcon, Settings as SettingsIcon } from "@material-ui/icons";
import { toast } from "react-toastify";
import api from "../../../services/api";

// Configuração independente por empresa. A senha jamais retorna ao navegador.
const EmailSettings = () => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [testing, setTesting] = useState(false);
  const [configured, setConfigured] = useState(false);
  const [hasPassword, setHasPassword] = useState(false);
  const [form, setForm] = useState({ host: "", port: "587", user: "", pass: "", from: "" });
  const [recipient, setRecipient] = useState("");

  const load = async () => {
    const { data } = await api.get("/settings/smtp");
    setConfigured(Boolean(data.configured));
    setHasPassword(Boolean(data.hasPassword));
    setForm(prev => ({
      ...prev,
      host: data.host || "",
      port: String(data.port || 587),
      user: data.user || "",
      from: data.from || "",
      pass: ""
    }));
  };
  useEffect(() => {
    load().catch(() => toast.error("Não foi possível consultar o SMTP desta empresa."));
  }, []);
  const onField = name => event => {
    const value = event.target.value;
    setForm(prev => ({ ...prev, [name]: value }));
  };
  const save = async () => {
    if (!form.host.trim() || !form.user.trim() || (!hasPassword && !form.pass)) {
      toast.warn("Informe servidor, usuário e uma senha SMTP.");
      return;
    }
    setBusy(true);
    try {
      await api.put("/settings/smtp", form);
      await load();
      toast.success("SMTP validado e salvo para esta empresa.");
    } catch (error) {
      toast.error(error?.response?.data?.error || "Não foi possível salvar o SMTP.");
    } finally { setBusy(false); }
  };
  const sendTest = async () => {
    if (!recipient.trim()) { toast.warn("Informe o endereço de teste."); return; }
    setTesting(true);
    try {
      await api.post("/settings/test-email", { to: recipient.trim() });
      toast.success("E-mail de teste aceito pelo servidor SMTP. Verifique a caixa de entrada.");
    } catch (error) {
      toast.error(error?.response?.data?.error || "Falha no envio de teste.");
    } finally { setTesting(false); }
  };

  return (
    <Card variant="outlined" style={{ borderRadius: 16 }}>
      <CardContent>
        <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 12 }}>
          <EmailIcon style={{ color: "#3b82f6", fontSize: 30 }} />
          <Box flexGrow={1}>
            <Typography variant="subtitle1" style={{ fontWeight: 700 }}>E-mail corporativo (SMTP)</Typography>
            <Typography variant="body2" color="textSecondary">
              Conexão exclusiva desta empresa para cobranças, recibos e notificações.
            </Typography>
          </Box>
          <Chip size="small" color={configured ? "primary" : "default"}
            label={configured ? "Configurado" : "Não configurado"} />
          <Button variant="outlined" color="primary" startIcon={<SettingsIcon />}
            onClick={() => setOpen(value => !value)} style={{ textTransform: "none" }}>
            {open ? "Fechar" : "Configurar"}
          </Button>
        </Box>
        {open && (
          <Box mt={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <TextField fullWidth variant="outlined" size="small" label="Servidor SMTP"
                  value={form.host} onChange={onField("host")} placeholder="smtp.hostinger.com" />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField fullWidth variant="outlined" size="small" label="Porta"
                  value={form.port} onChange={onField("port")} placeholder="465 ou 587" />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField fullWidth variant="outlined" size="small" label="Usuário / E-mail"
                  value={form.user} onChange={onField("user")} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField fullWidth variant="outlined" size="small" type="password"
                  autoComplete="new-password" label={hasPassword ? "Nova senha (deixe vazio para manter)" : "Senha SMTP"}
                  value={form.pass} onChange={onField("pass")} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth variant="outlined" size="small" label="Remetente"
                  value={form.from} onChange={onField("from")}
                  placeholder="Nome da empresa <financeiro@empresa.com.br>" />
              </Grid>
            </Grid>
            <Box mt={2}>
              <Button variant="contained" color="primary" onClick={save} disabled={busy}
                style={{ textTransform: "none", marginRight: 12 }}>
                {busy ? <CircularProgress size={18} /> : "Testar conexão e salvar"}
              </Button>
            </Box>
            <Box mt={3}>
              <Typography variant="subtitle2">Enviar e-mail de teste</Typography>
              <Box display="flex" flexWrap="wrap" alignItems="center" mt={1} style={{ gap: 12 }}>
                <TextField variant="outlined" size="small" type="email" label="Destinatário de teste"
                  value={recipient} onChange={e => setRecipient(e.target.value)} style={{ minWidth: 260 }} />
                <Button variant="outlined" onClick={sendTest} disabled={testing || !configured}
                  style={{ textTransform: "none" }}>
                  {testing ? <CircularProgress size={18} /> : "Enviar teste"}
                </Button>
              </Box>
              <Typography variant="caption" color="textSecondary">
                O teste usa exclusivamente as credenciais desta empresa. A senha existente nunca é exibida.
              </Typography>
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
export default EmailSettings;
